<div class="single-stat-widget-container" [@listAnimation]="(data || []).length">
    @if ((data || []).length) {
        <div class="single-stat-header">Other Metrics</div>
    }
    @for (item of data || []; track $index) {
        <div
            class="single-stat-container"
            [ngClass]="item.loading ? 'undefined' : 'bg-' + item.color"
            [class.full]="item.full"
            (click)="showPopup(item.id, item.version)"
        >
            @if (showInfo && item.info) {
                <mat-icon class="helper-icon" (click)="displayInfo($event, item.info)" fontSet="material-icons-outlined">help_outline</mat-icon>
            }
            <div class="single-stat-label">
                {{ item.label }} <span class="text-xs mx-2 text-dark-400">{{ item.nameSuffix }}</span>
            </div>
            <div class="single-stat-value">
                @if (!item.loading) {
                    <span
                        >{{ item.value }}
                        @if (item.threshold !== undefined && item.value !== 'NO DATA') {
                            <span>/ {{ item.threshold }}</span>
                        }
                    </span>
                } @else {
                    <mat-progress-spinner class="loading-container" [diameter]="20" [mode]="'indeterminate'"> </mat-progress-spinner>
                }
            </div>
        </div>
    }
</div>
